import React from 'react';
import { updateCompanyWithGetStartedData } from '../../../../utils';
import { ESellerStore as Platform } from '../../../..//Types';
import Signup from './Signup';

interface HandlePostSignUp {
  passedMinRevenue: boolean;
  platform: Platform;
  leadId: string;
}

export default function Signup8fig() {
  async function handlePostSignUp({
    passedMinRevenue,
    platform,
    leadId,
  }: HandlePostSignUp) {
    await updateCompanyWithGetStartedData({
      passedMinRevenue,
      platform,
      leadId,
    });
  }
  return (
    <Signup
      enableGoogleSignIn={true}
      handlePostSignUp={handlePostSignUp}
      enableBack={true}
    />
  );
}
